module.exports = __webpack_public_path__ + "img/charity-6.5dcaf3b6.png";